import { style, styleVariants } from '@vanilla-extract/css';
import {
  bodyTextPreset,
  borderWidthVars,
  fontWeightVars,
  spacingVars,
  titleTextPreset,
} from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { FeedbackMessageVariant } from './FeedbackMessage.types';

const FEEDBACK_MESSAGE_BORDER_RADIUS = '12px';
const ICON_CIRCLE_SIZE = '46px';
const GLOBAL_PADDING = '15px';

export const inlineContainerClass = style({
  display: 'flex',
  alignItems: 'flex-start',
  padding: spacingVars.md,
  gap: spacingVars.lg,
  borderRadius: FEEDBACK_MESSAGE_BORDER_RADIUS,
  overflow: 'clip',
});

export const globalContainerClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: GLOBAL_PADDING,
  borderBottomWidth: borderWidthVars.xs,
  borderBottomStyle: 'solid',
  width: '100%',
});

export const containerVariantClass = styleVariants({
  [FeedbackMessageVariant.INFO]: {
    backgroundColor: semanticTokenVars.feedback.info.default.subtle,
  },
  [FeedbackMessageVariant.WARNING]: {
    backgroundColor: semanticTokenVars.feedback.warning.default.subtle,
  },
  [FeedbackMessageVariant.ERROR]: {
    backgroundColor: semanticTokenVars.feedback.error.default.subtle,
  },
});

export const fullWidthClass = style({
  width: '100%',
});

export const inlineSectionClass = style({
  display: 'flex',
  flex: 1,
  gap: spacingVars.md,
  alignItems: 'flex-start',
  minWidth: 0,
});

export const globalSectionClass = style({
  display: 'flex',
  gap: spacingVars.md,
  alignItems: 'center',
  minWidth: 0,
});

export const iconCircleClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: ICON_CIRCLE_SIZE,
  minWidth: ICON_CIRCLE_SIZE,
  height: ICON_CIRCLE_SIZE,
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.raised,
});

export const iconCircleVariantClass = styleVariants({
  [FeedbackMessageVariant.INFO]: {
    color: semanticTokenVars.feedback.info.default.base,
  },
  [FeedbackMessageVariant.WARNING]: {
    color: semanticTokenVars.feedback.warning.default.base,
  },
  [FeedbackMessageVariant.ERROR]: {
    color: semanticTokenVars.feedback.error.default.base,
  },
});

export const innerContentRightClass = style({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: spacingVars['3xl'],
  minWidth: 0,
});

export const innerContentBottomClass = style({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: spacingVars.md,
  alignItems: 'flex-start',
  minWidth: 0,
});

export const textBoxClass = style({
  display: 'flex',
  flexDirection: 'column',
});

export const messageClass = style(titleTextPreset);

export const descriptionClass = style(bodyTextPreset);

export const linkButtonOverrideClass = style({
  height: 'auto',
  minHeight: 'auto',
  fontWeight: fontWeightVars.regular,
});

export const linkGroupClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: spacingVars.xs,
  color: semanticTokenVars.content.default.default,
  selectors: {
    '&:hover': {
      color: semanticTokenVars.content.subtle.default,
    },
  },
});
